export default "__VITE_ASSET__1f71923b__"